import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Alert,
  Easing,
  PanResponder,
  Animated,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
  HEIGHT,
} from "app/utils/styleSheet";
import Text from "app/components/Text";

export default class Wheel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pan: new Animated.ValueXY(),
      rotation: new Animated.Value(),
      startingRot: 0,
      startingAngle: 0,
      panResponder: PanResponder.create({
        // Ask to be the responder:
        onStartShouldSetPanResponder: (evt, gestureState) => {
          if (this.props.disabled) return false;
          const shouldSet = !(gestureState.dx === 0 && gestureState.dy === 0);
          // console.log(shouldSet, this.state.rotation)
          return shouldSet;
          return !(gestureState.dx === 0 && gestureState.dy === 0);
          // true,
        },
        onStartShouldSetPanResponderCapture: (evt, gestureState) => {
          if (this.props.disabled) return false;
          const shouldCapture = !(
            gestureState.dx === 0 && gestureState.dy === 0
          );
          // console.log(shouldCapture, this.state.rotation)
          return shouldCapture;
          return !(gestureState.dx === 0 && gestureState.dy === 0);
          // false, //true,
        },
        onMoveShouldSetPanResponder: (evt, gestureState) => {
          if (this.props.disabled) return false;
          const shouldSet = !(gestureState.dx === 0 && gestureState.dy === 0);
          // console.log(shouldSet, this.state.rotation)
          return shouldSet;
          // return true
          return !(gestureState.dx === 0 && gestureState.dy === 0);
          // true,
        },
        onMoveShouldSetPanResponderCapture: (evt, gestureState) => {
          if (this.props.disabled) return false;
          const shouldCapture = !(
            gestureState.dx === 0 && gestureState.dy === 0
          );
          if (shouldCapture) {
            // // const cx = WIDTH/2
            // // let statusBarHeight = (65+37) // fix this
            // // let cy = (HEIGHT-statusBarHeight)/2
            // // let p1 = { x: cx, y: cy };
            // // // let p2 = { x: gestureState.moveX, y: gestureState.moveY };
            // // let p0 = { x: gestureState.x0, y: gestureState.y0 };
            // // let startingAngle = Math.atan2(p0.y - p1.y, p0.x - p1.x) * 180 / Math.PI;
            // console.log(shouldCapture, this.state.rotation, startingAngle)
            // this.setState({startingRot: this.state.rotation, startingAngle})
          }
          return shouldCapture;
          // return true
          return !(gestureState.dx === 0 && gestureState.dy === 0);
          // false, //true,
        },
        onPanResponderGrant: (evt, gestureState) => {
          console.log("grant");
          // gestureState.d{x,y} will be set to zero now
          this.state.pan.setOffset(this.state.pan.__getValue());
          this.state.pan.setValue({ x: 0, y: 0 });

          const cx = WIDTH / 2;
          let statusBarHeight = 65 + 37; // fix this
          let cy = (HEIGHT - statusBarHeight) / 2;
          let p1 = { x: cx, y: cy };
          let p2 = { x: gestureState.moveX, y: gestureState.moveY };
          let p0 = { x: gestureState.x0, y: gestureState.y0 };
          let startingAngle =
            (Math.atan2(p0.y - p1.y, p0.x - p1.x) * 180) / Math.PI;
          console.warn(startingAngle);

          // // console.log(shouldCapture, this.state.rotation, startingAngle)
          // this.setState({startingAngle})

          // console.warn(this.state.rotation.__getValue(), startingAngle)
          console.warn(this.state.rotation.__getValue());
          // this.state.rotation.setOffset(this.state.rotation.__getValue())
          this.state.rotation.setOffset(-startingAngle);

          // this.state.rotation.setValue(0)
          // this.state.rotation.setOffset(startingAngle)
          this.state.rotation.setValue(startingAngle);
        },
        onPanResponderMove: (evt, gestureState) => {
          if (this.props.onPan) {
            this.props.onPan(gestureState);
            // return
          }

          // multitouches
          const touches = evt.nativeEvent.touches;
          if (touches.length >= 2) {
            // We have a pinch-to-zoom movement
            // Track locationX/locationY to know by how much the user moved their fingers
            console.log(touches);

            // touches[0].changedTouches

            // Array [
            //   Object {
            //     "changedTouches": Array [
            //       [Circular],
            //       Object {
            //         "identifier": 2,
            //         "locationX": 25.5,
            //         "locationY": 76.5,
            //         "pageX": 129,
            //         "pageY": 498.5,
            //         "target": 3639,
            //         "timestamp": 14192060.857306002,
            //       },
            //     ],
            //     "identifier": 1,
            //     "locationX": 285,
            //     "locationY": 249,
            //     "pageX": 285,
            //     "pageY": 397.5,
            //     "target": 293,
            //     "timestamp": 14192060.857306002,
            //     "touches": [Circular],
            //   },
            //   Object {
            //     "identifier": 2,
            //     "locationX": 25.5,
            //     "locationY": 76.5,
            //     "pageX": 129,
            //     "pageY": 498.5,
            //     "target": 3639,
            //     "timestamp": 14192060.857306002,
            //   },
            // ]
            return;
          }

          let { dx, dy } = gestureState;
          const cx = WIDTH / 2;
          let statusBarHeight = 65 + 37; // fix this
          let cy = (HEIGHT - statusBarHeight) / 2;
          let p1 = { x: cx, y: cy };
          let p2 = { x: gestureState.moveX, y: gestureState.moveY };
          // angle in radians
          // let  angleRadians = Math.atan2(p2.y - p1.y, p2.x - p1.x);
          // angle in degrees
          let angleDeg = (Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180) / Math.PI;
          let rotation = angleDeg;
          // console.log(angleDeg)
          // console.log(gestureState.dx, gestureState.moveX, gestureState.x0)

          // let p0 = { x: gestureState.x0, y: gestureState.y0 };
          // let angleDegIDFK = Math.atan2(p0.y - p1.y, p0.x - p1.x) * 180 / Math.PI;

          // console.log(angleDeg, angleDegIDFK)
          rotation -= this.state.startingAngle;
          // rotation -= this.state.startingRot

          // console.log(angleDeg, angleDegIDFK, rotation)

          Animated.event([
            null,
            {
              rotation: this.state.rotation,
              useNativeDriver: !ENV.WEB,
            },
          ])(evt, { rotation });

          Animated.event([
            null,
            {
              dx: this.state.pan.x,
              dy: this.state.pan.y,
              useNativeDriver: !ENV.WEB,
            },
          ])(evt, gestureState);
        },
        // onPanResponderMove: Animated.event([
        //     null,
        //     { dx: this.state.pan.x, dy: this.state.pan.y }
        //   ]),
        onPanResponderTerminationRequest: (evt, gestureState) => true,
        onPanResponderRelease: (evt, gestureState) => {
          let { vx, vy, moveX } = gestureState;
          console.log("release:", vx);
          this.state.pan.flattenOffset();
          this.state.rotation.flattenOffset();

          const velocityThreshold = ENV.WEB ? 0.1 : 15;
          const deceleration = ENV.WEB ? 0.99 : 0.96;

          if (Math.abs(vx) > velocityThreshold) {
            // Animated.decay(this.state.pan, {
            //   // velocity: {x: vx*5, y: vy},
            //   velocity: {x: vx, y: vy},
            //   deceleration,
            // }).start(() => {
            //   console.log('decay complete')
            // })
            let v = (Math.abs(vx) + Math.abs(vy)) / 2;
            Animated.decay(this.state.rotation, {
              velocity: v,
              deceleration,
            }).start(() => {
              console.log("decay complete");
            });
          } else if (true) {
            // else if(!!this.props.yThreshold && gestureState.moveY < this.props.yThreshold){
            console.log("just flatten");
            // this.state.pan.flattenOffset();
          } else {
            console.log("spring back");
            // this.state.pan.flattenOffset();
            Animated.spring(this.state.pan, {
              toValue: { x: 0, y: 0 },
              friction: 10,
              useNativeDriver: !ENV.WEB,
            }).start();
          }
        },
        onPanResponderTerminate: (evt, gestureState) => {
          // Another component has become the responder, so this gesture
          // should be cancelled
        },
        onShouldBlockNativeResponder: (evt, gestureState) => {
          // Returns whether this component should block native components from becoming the JS
          // responder. Returns true by default. Is currently only supported on android.
          return true;
        },
      }),
    };
    this.inputRange = WIDTH * 3;
  }

  componentDidMount() {
    if (this.props.initialRotation) {
      let spinAmount = this.inputRange * 0.6;
      // this.state.pan.setValue({x: spinAmount*this.props.initialRotation, y: 0})
      // Animated.timing(this.state.pan, {
      //   toValue: { x: 0, y: 0 },
      //   duration: 1000,
      //   delay: 200,
      //   easing: Easing.out(Easing.circle),
      //   useNativeDriver: !ENV.WEB,
      // }).start()
      let spinAmountDeg = 180;
      this.state.rotation.setValue(spinAmountDeg * this.props.initialRotation);
      Animated.timing(this.state.rotation, {
        toValue: 0,
        duration: 1700,
        delay: 100,
        easing: Easing.out(Easing.circle),
        useNativeDriver: !ENV.WEB,
      }).start();
    }
  }

  resetRotation = () => {
    // Animated.timing(this.state.pan, {
    //   toValue: { x: 0, y: 0 },
    //   duration: 1000,
    //   delay: 200,
    //   easing: Easing.out(Easing.circle),
    //   useNativeDriver: !ENV.WEB,
    // }).start()
    Animated.timing(this.state.rotation, {
      toValue: 0,
      duration: 1000,
      delay: 200,
      easing: Easing.out(Easing.circle),
      useNativeDriver: !ENV.WEB,
    }).start();
  };

  render() {
    let { size, scale } = this.props;
    let { pan, rotation } = this.state;
    let [translateX, translateY] = [pan.x, pan.y];

    // const rotate = translateX.interpolate({
    //    inputRange: [-this.inputRange, 0, this.inputRange],
    //    outputRange: ['360deg', '0deg', '-360deg']
    // });
    // const invertedRot = translateX.interpolate({
    //    inputRange: [-this.inputRange, 0, this.inputRange],
    //    outputRange: ['-360deg', '0deg', '360deg']
    // });

    const rot = rotation.interpolate({
      inputRange: [-360, 0, 360],
      outputRange: ["-360deg", "0deg", "360deg"],
    });
    const invertedRot = rotation.interpolate({
      inputRange: [-360, 0, 360],
      outputRange: ["360deg", "0deg", "-360deg"],
    });

    size = size || Math.max(WIDTH, HEIGHT) * scale;
    let borderRadiusStyle = { borderRadius: size / 2 };

    return (
      <View style={[styles.container, borderRadiusStyle, this.props.style]}>
        {/*<View style={{position: 'absolute', bottom: 0, left: '50%'}}>
            <Text style={{fontSize: 30}}>{translateX?._value}</Text>
          </View>*/}
        {!!pan && (
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "stretch",
              ...StyleSheet.absoluteFillObject,
              ...borderRadiusStyle,
            }}
          >
            <Animated.View
              useNativeDriver={true}
              style={[
                {
                  flex: 1,
                  alignSelf: "stretch",
                  flexDirection: "row",
                  // borderWidth: 10, borderColor: 'red',
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: size,
                  height: size,
                  ...borderRadiusStyle,
                },
                // {transform: [{ rotateZ: rotate}]},
                { transform: [{ rotateZ: rot }] },
              ]}
              {...this.state.panResponder.panHandlers}
            >
              {this.props.children(invertedRot)}
            </Animated.View>
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // flexDirection: 'column',
    justifyContent: "center",
    alignItems: "stretch",
    // borderWidth: 12, borderColor: 'skyblue',
  },
  content: {
    flex: 1,
    // borderWidth: 12, borderColor: 'orange',
  },
});
